/* tempexp_18086-start */
import { Text } from '@vkontakte/vkui';
import classNames from 'clsx';
import React, { type ReactNode } from 'react';

import styles from './ReferralInfoBlock.css';

interface ReferralInfoBlockItemProps {
    variant: '1' | '2' | '3';
    text: ReactNode;
}

export function ReferralInfoBlockItem({ variant, text }: ReferralInfoBlockItemProps) {
    return (
        <div
            className={classNames(styles.rootItem, {
                [styles[`rootItem-${variant}`]]: true,
            })}
        >
            <div className={styles.variant}>{variant}</div>
            <Text className={styles.text}>{text}</Text>
        </div>
    );
}

/* tempexp_18086-end */
